import React from 'react'
import { useTranslation } from 'react-i18next'
import { Label } from '@/components/ui/label'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
} from '@/components/ui/select'
import { AssetFormData } from '..'

interface BasicDetailsSectionProps {
    formData: AssetFormData
    setFormData: React.Dispatch<React.SetStateAction<AssetFormData>>
    departmentsData: any
    isDepartmentsLoading: boolean
}

const BasicDetailsSection: React.FC<BasicDetailsSectionProps> = ({
    formData,
    setFormData,
    departmentsData,
    isDepartmentsLoading,
}) => {
    const { t } = useTranslation('asset')

    return (
        <div className="rounded-lg border border-gray-100 bg-gray-50/40 p-4 space-y-4">
            <h4 className="text-sm font-medium text-gray-800">
                {t('form.basicDetails')}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                    <Label htmlFor="assetName">
                        {t('labels.assetName')}{' '}
                        <span className="text-destructive">*</span>
                    </Label>
                    <Input
                        id="assetName"
                        value={formData.assetName}
                        onChange={(e) =>
                            setFormData((prev) => ({
                                ...prev,
                                assetName: e.target.value,
                            }))
                        }
                        placeholder={t('placeholders.enterAssetName')}
                        maxLength={50}
                    />
                </div>
            </div>

            <div>
                <Label htmlFor="departmentId">
                    {t('labels.department')}{' '}
                    <span className="text-destructive">*</span>
                </Label>
                <Select
                    value={formData.departmentId}
                    onValueChange={(value) =>
                        setFormData((prev) => ({
                            ...prev,
                            departmentId: value,
                        }))
                    }
                    disabled={isDepartmentsLoading}
                >
                    <SelectTrigger>
                        <SelectValue
                            placeholder={
                                isDepartmentsLoading
                                    ? t('form.loading')
                                    : t('placeholders.selectDepartment')
                            }
                        />
                    </SelectTrigger>
                    <SelectContent>
                        {departmentsData?.results?.map((department: any) => (
                            <SelectItem
                                key={department.department_id}
                                value={department.department_id.toString()}
                            >
                                {department.department_name}
                            </SelectItem>
                        ))}
                    </SelectContent>
                </Select>
            </div>

            <div>
                <Label htmlFor="assetDescription">
                    {t('labels.assetDescription')}
                </Label>
                <Textarea
                    id="assetDescription"
                    value={formData.assetDescription}
                    onChange={(e) =>
                        setFormData((prev) => ({
                            ...prev,
                            assetDescription: e.target.value,
                        }))
                    }
                    placeholder={t('placeholders.enterAssetDescription')}
                    rows={3}
                />
            </div>
        </div>
    )
}

export default BasicDetailsSection
